import { PropTypes as MobxPropTypes, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DropdownItem } from 'reactstrap';

import globalTranslations from '../../../i18n/globalTranslations';
import Currency from '../../../models/Currency';
import { modelOf } from '../../../prop-types';
import DropdownSelect from '../../common/DropdownSelect';
import CurrencyLabel from '../CurrencyLabel';

const RegionalSettingsCurrencyDropdown = ({
  currency,
  currencies,
  onSelect,
  disabled: disabledProp,
  showLabelText,
  toggleClassName,
  toggleNav,
  positionFixed,
}) => {
  const disabled = currencies.length < 2 ? true : disabledProp;
  const selectedCurrencyLabel = currency.code;

  return (
    <DropdownSelect
      className="RegionalSettingsCurrencyDropdown"
      label={
        showLabelText ? (
          <FormattedMessage
            {...globalTranslations.currencyLabel}
            values={{
              currency: currency.code,
            }}
          />
        ) : (
          selectedCurrencyLabel
        )
      }
      disabled={disabled}
      focusSelectedItemOnKeyboardOpen
      focusToggleOnClose
      toggleClassName={toggleClassName}
      toggleNav={toggleNav}
      positionFixed={positionFixed}
    >
      {currencies.map((currencyOption) => {
        const isActive = currencyOption.code === currency.code;

        return (
          <DropdownItem
            onClick={() => onSelect(currencyOption)}
            key={currencyOption.code}
            active={isActive}
            aria-current={isActive ? 'true' : undefined}
          >
            <CurrencyLabel currency={currencyOption} />
          </DropdownItem>
        );
      })}
    </DropdownSelect>
  );
};

RegionalSettingsCurrencyDropdown.propTypes = {
  currency: modelOf(Currency).isRequired,
  currencies: MobxPropTypes.arrayOrObservableArrayOf(modelOf(Currency))
    .isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  showLabelText: PropTypes.bool,
  toggleClassName: PropTypes.string,
  toggleNav: PropTypes.bool,
  positionFixed: PropTypes.bool,
};

RegionalSettingsCurrencyDropdown.defaultProps = {
  disabled: false,
  showLabelText: true,
  toggleClassName: undefined,
  toggleNav: false,
  positionFixed: false,
};

export default observer(RegionalSettingsCurrencyDropdown);
